import React from 'react';
import './PrintDocument.css';
import { numberToWords } from 'helpers/NumberToWordHelper';
import ShopsHelper from 'helpers/ShopsHelper';
import { COUNTRY_CONFIGRATION, PAPER_SIZE, PRINT_TYPES } from 'const';
const ThreeInchInvoice = ({ data, shop, billFormat }) => {
    const items = data.items || [];
    const date = new Date(data.time || new Date());
    const formattedDate = date.toLocaleDateString('en-GB');
    const formattedTime = date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: true }).toUpperCase();

    const customer = data.customer || null;
    const shopName = billFormat?.shop_name || shop?.shop_name;

    const payments = data.payments || [];
    const totalPaid = payments.reduce((acc, curr) => acc + Number(curr.credit || 0), 0);
    const creditUsed = ((data.payable || 0)) - totalPaid;
    const prevBalance = Number(customer?.balance || 0) + creditUsed;

    const formatBalance = (balance) => {
        return balance >= 0 ? ShopsHelper.getAmountFormatted(shop, balance) : `(cr) ${ShopsHelper.getAmountFormatted(shop, Math.abs(balance))}`;
    };

    const grandTotal = items.reduce((sum, item) => sum + (item.payable || 0), 0);

    return (
        <div className="thermal-receipt print-only" style={{ width: '76.2mm', margin: '0', padding: '10px', fontFamily: 'monospace', fontSize: '13px', color: '#000', lineHeight: '1.2' }}>
            <style type="text/css" media="print">
                {`
                    @page { size: 76.2mm auto; margin: 0 !important; }
                    .thermal-receipt.print-only {
                        width: 76.2mm !important;
                    }
                `}
            </style>
            
            <div style={{ textAlign: 'center', marginBottom: '10px' }}>
                <h2 style={{ margin: '0 0 5px 0', fontSize: '18px' }}>{shopName}</h2>
                { billFormat?.address_1 && <div>{billFormat.address_1}</div> }
                { billFormat?.address_2 && <div>{billFormat.address_2}</div> }
                { billFormat?.address_3 && <div>{billFormat.address_3}</div> }
                { billFormat?.address_4 && <div>{billFormat.address_4}</div> }
                { billFormat?.tel_no && <div>{billFormat.tel_no}</div> }
                { billFormat?.tin && <div>{billFormat.tin}</div> }
            </div>
            
            <div style={{ borderBottom: '1px dashed black', margin: '5px 0' }}></div>
            
            <div style={{ margin: '5px 0' }}>
                <div>Bill no: {data.bill_no}</div>
                <div>Date: {formattedDate}</div>
                <div>Time: {formattedTime}</div>
                {customer && (
                    <>
                        <div>Customer: {customer.name}</div>
                        <div>Mobile: {customer.mobile}</div>
                        {customer.points && <div>Loyalty points: {customer.points}</div>}
                    </>
                )}
            </div>
            
            <div style={{ borderBottom: '1px dashed black', margin: '5px 0' }}></div>
            
            <div style={{ display: 'flex', fontWeight: 'bold', margin: '5px 0' }}>
                <span style={{ width: '10%' }}>#</span>
                <span style={{ width: '40%' }}>Item</span>
                <span style={{ width: '20%', textAlign: 'right' }}>Price</span>
                <span style={{ width: '10%', textAlign: 'right' }}>Qty</span>
                <span style={{ width: '20%', textAlign: 'right' }}>Total</span>
            </div>
            
            <div style={{ borderBottom: '1px dashed black', margin: '5px 0' }}></div>
            
            <div>
                {items.map((item, index) => (
                    <div key={index} style={{ display: 'flex', flexDirection: 'column', marginBottom: '8px' }}>
                        <div style={{ display: 'flex' }}>
                            <span style={{ width: '10%' }}>{index + 1}</span>
                            <span style={{ width: '90%' }}>{item.name || item.item?.name || item.description}</span>
                        </div>
                        <div style={{ display: 'flex' }}>
                            <span style={{ width: '50%' }}></span>
                            <span style={{ width: '20%', textAlign: 'right' }}>{ShopsHelper.getAmountFormatted(shop, parseFloat(item.rate || 0))}</span>
                            <span style={{ width: '10%', textAlign: 'right' }}>{ShopsHelper.getAmountFormatted(shop, item.quantity || 0)}</span>
                            <span style={{ width: '20%', textAlign: 'right' }}>{ShopsHelper.getAmountFormatted(shop, parseFloat(item.payable || 0))}</span>
                        </div>
                    </div>
                ))}
                
                <div style={{ display: 'flex', marginTop: '5px', marginBottom: '5px' }}>
                    <span style={{ width: '10%' }}>{items.length + 1}</span>
                    <span style={{ width: '60%' }}>Discount</span>
                    <span style={{ width: '30%', textAlign: 'right', paddingRight: '2px' }}>{ShopsHelper.getAmountFormatted(shop, parseFloat(data.discount_applied_on_items || 0))}</span>
                </div>
            </div>
            
            {shop?.tax_region === COUNTRY_CONFIGRATION.IN.name ? (
                <>
                    <div style={{ display: 'flex', justifyContent: 'space-between', margin: '5px 0' }}>
                        <span style={{ paddingLeft: '30%' }}>CGST :</span>
                        <span>{(items.reduce((sum, item) => sum + (item.tax || 0) + (item.cess || 0), 0) / 2).toFixed(2)}</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', margin: '5px 0' }}>
                        <span style={{ paddingLeft: '30%' }}>SGST :</span>
                        <span>{(items.reduce((sum, item) => sum + (item.tax || 0) + (item.cess || 0), 0) / 2).toFixed(2)}</span>
                    </div>
                </>
            ) : null}
            
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '15px', fontWeight: 'bold', margin: '10px 0' }}>
                <span style={{ paddingLeft: '30%' }}>Total :</span>
                <span>{ShopsHelper.getAmountFormatted(shop, parseFloat(grandTotal))}</span>
            </div>

            {customer && (
                <div style={{ borderTop: '1px dashed black', paddingTop: '5px', marginTop: '10px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span>Prev Balance:</span>
                        <span>{formatBalance(prevBalance)}</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span>Current Balance:</span>
                        <span>{formatBalance(customer.balance || 0)}</span>
                    </div>
                </div>
            )}
            
            <div style={{ textAlign: 'center', fontSize: '14px', margin: '15px 0', lineHeight: '1.4' }}>
                {billFormat?.footer_1 && <div>{billFormat.footer_1}</div>}
                {billFormat?.footer_2 && <div>{billFormat.footer_2}</div>}
            </div>
        </div>
    );
};
const PrintDocument = ({ data, type = PRINT_TYPES.SALE, shop, billFormat, totals, paperSize = PAPER_SIZE.A4 }) => {
    if (!data || !shop) return null;

    if (paperSize === PAPER_SIZE.THERMAL_80MM && type !== PRINT_TYPES.ESTIMATE) {
        return <ThreeInchInvoice data={data} shop={shop} billFormat={billFormat} totals={totals} />;
    }

    const items = data.items || [];
    const date = new Date(data.time || new Date());
    const formattedDate = date.toLocaleDateString('en-GB');
    const formattedTime = date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: true }).toUpperCase();

    const customer = data.customer || null;
    const shopName = billFormat?.shop_name || shop?.shop_name;

    const formatBalance = (balance) => {
        return balance >= 0 ? ShopsHelper.getAmountFormatted(shop, balance) : `(cr) ${ShopsHelper.getAmountFormatted(shop, Math.abs(balance))}`;
    };

    const payments = data.payments || [];
    const totalPaid = payments.reduce((acc, curr) => acc + Number(curr.credit || 0), 0);
    const creditUsed = (totals?.payable || 0) - totalPaid;
    const prevBalance = Number(customer?.balance || 0) + creditUsed;

    const totalQuantity = items.reduce((acc, item) => acc + Number(item.quantity), 0);
    const documentTitle = type === PRINT_TYPES.ESTIMATE ? 'ESTIMATE' : 'TAX INVOICE';
    const documentNumberLabel = type === PRINT_TYPES.ESTIMATE ? 'Estimate No' : 'Invoice No';
    const documentNumber = data.bill_no || data.estimate_no;

    const totalTaxVal = (totals?.tax || 0) + (totals?.cess || 0);
    const discountAppliedOnItems = data.discount_applied_on_items || 0;
    const totalAmountVal = (totals?.payable || 0) - totalTaxVal + discountAppliedOnItems;

    return (
        <div className={`print-document-container print-only size-${paperSize.toLowerCase().replace('.', '_')}`}>
            <style type="text/css" media="print">
                {`@page { size: ${paperSize} portrait; margin: 0 !important; }`}
            </style>

            <div className="print-header">
                <h1 className="shop-name">{shopName}</h1>
                <div className="shop-details">
                    { (billFormat?.address_1 || shop?.address) && <div>{billFormat?.address_1 || shop?.address}</div> }
                    { (billFormat?.address_2) && <div>{billFormat?.address_2}</div> }
                    { (billFormat?.address_3) && <div>{billFormat?.address_3}</div> }
                    { (billFormat?.address_4) && <div>{billFormat?.address_4}</div> }
                    { (billFormat?.tel_no || shop?.mobile_no || shop?.phone) && <div>{billFormat?.tel_no || shop?.mobile_no || shop?.phone}</div> }
                    { (billFormat?.tin) && <div>{shop?.tax_type === 'GST' || shop?.tax_type === 'IGST' ? 'GSTIN' : 'TAX ID'} : {billFormat?.tin}</div> }
                </div>
            </div>

            <div className="thick-divider"></div>

            <div className="document-title-container">
                <h2 className="document-title">{documentTitle}</h2>
            </div>
            
            <div className="info-box" style={{ display: 'flex' }}>
                <div style={{ display: 'flex', width: '50%' }}>
                    <div className="info-label-cell">{documentNumberLabel}</div>
                    <div className="info-colon">:</div>
                    <div className="info-value-cell">{documentNumber}</div>
                </div>
                <div style={{ display: 'flex', width: '50%' }}>
                    <div className="info-label-cell" style={{ width: 'auto', paddingRight: '5px' }}>Date:</div>
                    <div className="info-value-cell">{formattedDate} {formattedTime}</div>
                </div>
            </div>

            <div className="info-box">
                <table className="info-table-layout">
                    <tbody>
                        <tr>
                            <td className="info-label-cell">Mobile</td>
                            <td className="info-colon">:</td>
                            <td className="info-value-cell">{customer?.mobile || '-'}</td>
                        </tr>
                        <tr>
                            <td className="info-label-cell">Customer</td>
                            <td className="info-colon">:</td>
                            <td className="info-value-cell">{customer?.name || '-'}</td>
                        </tr>
                        <tr>
                            <td className="info-label-cell">Address</td>
                            <td className="info-colon">:</td>
                            <td className="info-value-cell">{customer?.address || '-'}</td>
                        </tr>
                        {customer?.trn_number && (
                            <tr>
                                <td className="info-label-cell">{shop?.tax_type === 'GST' || shop?.tax_type === 'IGST' ? 'GSTIN' : 'TAX ID'}</td>
                                <td className="info-colon">:</td>
                                <td className="info-value-cell">{customer.trn_number}</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <table className="items-table">
                <thead>
                    <tr>
                        <th className="col-index">#</th>
                        <th className="col-desc">Item</th>
                        <th className="col-hsn">HSN</th>
                        <th className="col-qty">Qty</th>
                        <th className="col-rate">Price</th>
                        <th className="col-tax">Tax</th>
                        <th className="col-tax">Tax%</th>
                        <th className="col-total">Total</th>
                    </tr>
                </thead>
                <tbody>
                    {items.length === 0 && (
                        <tr className="empty-row">
                            <td></td><td></td><td></td><td></td><td></td><td></td><td></td>
                        </tr>
                    )}
                    {items.map((item, index) => {
                        const itemPrice = item.rate || 0;
                        const itemTax = item.tax || 0;
                        const itemTotal = item.payable || 0;
                        
                        return (
                            <tr key={index}>
                                <td className="text-center">{index + 1}</td>
                                <td>
                                    <div className="item-name">{item.name || item.item?.name || item.description}</div>
                                    {(item.name || item.item?.name) && item.description && <div className="item-description">{item.description}</div>}
                                </td>
                                <td className="text-center">{item.hsn || item.item?.hsn || '0'}</td>
                                <td className="text-center">{ShopsHelper.getAmountFormatted(shop, item.quantity)}</td>
                                <td className="text-right">{ShopsHelper.getAmountFormatted(shop, parseFloat(itemPrice))}</td>
                                <td className="text-right">{ShopsHelper.getAmountFormatted(shop, parseFloat(itemTax))}</td>
                                <td className="text-center">{Number(item.item?.tax || 0)}%</td>
                                <td className="text-right">{ShopsHelper.getAmountFormatted(shop, parseFloat(itemTotal))}</td>
                            </tr>
                        );
                    })}

                    {(paperSize === PAPER_SIZE.A4 || paperSize === PAPER_SIZE.A5) && items.length < (paperSize === PAPER_SIZE.A4 ? 18 : 6) && (
                        <tr key="blank-spacer" style={{ height: (paperSize === PAPER_SIZE.A4 ? (18 - items.length) * 25 : (6 - items.length) * 20) + 'px' }}>
                            <td colSpan="8" style={{ border: 'none' }}></td>
                        </tr>
                    )}

                    <tr className="summary-row">
                        <td colSpan="3" className="text-right px-2"><strong>Total:</strong></td>
                        <td className="text-center"><strong>{ShopsHelper.getAmountFormatted(shop, totalQuantity)}</strong></td>
                        <td></td>
                        <td className="text-right px-2"><strong>{ShopsHelper.getAmountFormatted(shop, totals?.tax || 0)}</strong></td>
                        <td></td>
                        <td className="text-right px-2"><strong>{ShopsHelper.getAmountFormatted(shop, totals?.payable || 0)}</strong></td>
                    </tr>

                    {data.remark && (
                        <tr>
                            <td colSpan="8" className="text-left px-2" style={{ paddingTop: '10px' }}>
                                <strong>Remark:</strong> {data.remark}
                            </td>
                        </tr>
                    )}
                    <tr>
                        <td colSpan="7" className="text-right px-2" style={{ paddingTop: '10px' }}><strong>Total Amount:</strong></td>
                        <td className="text-right px-2" style={{ paddingTop: '10px' }}><strong>{ShopsHelper.getAmountFormatted(shop, totalAmountVal)}</strong></td>
                    </tr>
                    {totalTaxVal > 0 && (
                        <>
                            {shop?.tax_region === COUNTRY_CONFIGRATION.IN.name ? (
                                <>
                                    <tr>
                                        <td colSpan="7" className="text-right px-2"><strong>CGST:</strong></td>
                                        <td className="text-right px-2"><strong>{(totalTaxVal / 2).toFixed(2)}</strong></td>
                                    </tr>
                                    <tr>
                                        <td colSpan="7" className="text-right px-2"><strong>SGST:</strong></td>
                                        <td className="text-right px-2"><strong>{(totalTaxVal / 2).toFixed(2)}</strong></td>
                                    </tr>
                                </>
                            ) : (
                                <tr>
                                    <td colSpan="7" className="text-right px-2"><strong>Total Tax:</strong></td>
                                    <td className="text-right px-2"><strong>{totalTaxVal.toFixed(2)}</strong></td>
                                </tr>
                            )}
                        </>
                    )}
                    {discountAppliedOnItems > 0 && (
                        <tr>
                            <td colSpan="7" className="text-right px-2"><strong>Discount:</strong></td>
                            <td className="text-right px-2"><strong>{discountAppliedOnItems.toFixed(2)}</strong></td>
                        </tr>
                    )}
                    <tr>
                        <td colSpan="7" className="text-right px-2" style={{fontSize: '16px'}}><strong>Payable:</strong></td>
                        <td className="text-right px-2" style={{fontSize: '16px'}}><strong>{(totals?.payable || 0).toFixed(2)}</strong></td>
                    </tr>
                    
                    {type !== PRINT_TYPES.ESTIMATE && customer && (
                        <>
                            <tr>
                                <td colSpan="7" className="text-right px-2"><strong>Prev Balance:</strong></td>
                                <td className="text-right px-2"><strong>{formatBalance(prevBalance)}</strong></td>
                            </tr>
                            <tr>
                                <td colSpan="7" className="text-right px-2" style={{fontSize: '16px'}}><strong>Balance:</strong></td>
                                        <td className="text-right px-2" style={{fontSize: '16px'}}><strong>{formatBalance(Number(customer.balance || 0))}</strong></td>
                                    </tr>
                        </>
                    )}
                    <tr>
                        <td colSpan="8" className="footer-cell">
                            <div style={{ textAlign: 'left', marginBottom: '8px' }}>
                                Amount in words: <span className="ml-2 font-bold">{numberToWords(totals?.payable || 0)}</span>
                            </div>
                            <div style={{ textAlign: 'center' }}>
                                {billFormat?.footer_1 && <div>{billFormat.footer_1}</div>}
                                {billFormat?.footer_2 && <div>{billFormat.footer_2}</div>}
                                {!billFormat?.footer_1 && !billFormat?.footer_2 && <div>www.sanoft.com</div>}
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div className="page-footer-info mt-4">
                <div style={{ flex: 1 }}></div>
                <div style={{ flex: 1, textAlign: 'center' }}>1 / 1</div>
                <div style={{ flex: 1, textAlign: 'right' }}>w1.0.15</div>
            </div>
        </div>
    );
};

export default PrintDocument;
